import { Link } from "react-router-dom";
import "../App.css";

export default function Terms() {
  return (
    <div className="inkflow-page ink-legal-page">
      <nav className="ink-nav s">
        <Link to="/" className="ink-logo" data-testid="logo-link">
          INK<span>FLOW</span>
        </Link>
        <Link to="/" className="ink-nav-cta">Back to home</Link>
      </nav>

      <main className="ink-legal-wrap">
        <div className="ink-eyebrow" style={{ marginBottom: 24 }}>
          <div className="ink-eyebrow-line"></div>
          <span>Legal</span>
        </div>
        <h1 className="ink-legal-title">Algemene Voorwaarden</h1>
        <p className="ink-legal-meta">Laatste update: 13 mei 2026</p>

        <section className="ink-legal-section">
          <h2>1. Algemeen</h2>
          <p>
            Deze algemene voorwaarden zijn van toepassing op alle diensten geleverd
            door <strong>Inkflow / Agency Escape</strong>, met maatschappelijke zetel
            te <strong>Bergekouter 132, 9300 Aalst, België</strong>, ingeschreven onder
            BTW-nummer <strong>BE1005105981</strong> (hierna "wij", "ons" of "Inkflow").
          </p>
          <p>
            Door gebruik te maken van onze website of door één van onze diensten af te
            nemen, gaat de klant ("u") akkoord met deze voorwaarden.
          </p>
        </section>

        <section className="ink-legal-section">
          <h2>2. Diensten</h2>
          <p>
            Inkflow biedt 1-op-1 coaching aan voor tatoeagekunstenaars met als doel
            een consistente klantenstroom op te bouwen via organische marketing.
            De inhoud van het programma is beschreven op deze website.
          </p>
        </section>

        <section className="ink-legal-section">
          <h2>3. Aanmelding en aanvaarding</h2>
          <p>
            Aanmelding gebeurt via een kennismakingsgesprek. Wij behouden ons het
            recht voor om kandidaten te weigeren wanneer er onvoldoende fit is met
            ons programma.
          </p>
        </section>

        <section className="ink-legal-section">
          <h2>4. Prijs en betaling</h2>
          <p>
            De prijs voor het 3-maanden coachingsprogramma bedraagt <strong>€800 per
            maand</strong> (BTW inbegrepen indien van toepassing volgens artikel 44 W.BTW
            of vrijgesteld), gefactureerd vooraf per maand. Het programma loopt over
            een termijn van 3 maanden.
          </p>
          <p>
            Facturen zijn betaalbaar binnen 14 dagen na factuurdatum. Bij niet-tijdige
            betaling is van rechtswege en zonder ingebrekestelling een verwijlinterest
            verschuldigd zoals voorzien in de Wet betreffende de bestrijding van de
            betalingsachterstand bij handelstransacties, vermeerderd met een
            forfaitaire schadevergoeding van 10% met een minimum van €40.
          </p>
        </section>

        <section className="ink-legal-section">
          <h2>5. Geld-terug-garantie</h2>
          <p>
            Indien u na de eerste maand actief deelnemen geen waarde ervaart, kunt u
            schriftelijk vragen om terugbetaling van uw eerste betaling. Dit verzoek
            moet uiterlijk binnen 7 dagen na het einde van de eerste maand worden
            ingediend. Bij terugbetaling vervalt de toegang tot het programma onmiddellijk.
          </p>
        </section>

        <section className="ink-legal-section">
          <h2>6. Verplichtingen van de klant</h2>
          <ul>
            <li>U engageert zich om actief deel te nemen aan de wekelijkse calls.</li>
            <li>U voert de overeengekomen acties uit binnen redelijke termijnen.</li>
            <li>U geeft eerlijke en correcte informatie tijdens onze samenwerking.</li>
          </ul>
        </section>

        <section className="ink-legal-section">
          <h2>7. Intellectuele eigendom</h2>
          <p>
            Alle materialen (strategieën, sjablonen, content-plannen, opnames)
            blijven eigendom van Inkflow. U krijgt een persoonlijke, niet-overdraagbare
            licentie om dit materiaal te gebruiken binnen uw eigen tattoo-praktijk.
            Doorverkopen of publiek delen is niet toegestaan zonder schriftelijke
            toestemming.
          </p>
        </section>

        <section className="ink-legal-section">
          <h2>8. Aansprakelijkheid</h2>
          <p>
            Inkflow levert een inspanningsverbintenis, geen resultaatsverbintenis.
            Resultaten zijn mede afhankelijk van uw eigen inzet en uitvoering. Onze
            aansprakelijkheid is in elk geval beperkt tot het bedrag dat u onder
            het lopende contract heeft betaald.
          </p>
        </section>

        <section className="ink-legal-section">
          <h2>9. Privacy</h2>
          <p>
            Persoonsgegevens worden verwerkt zoals beschreven in onze{" "}
            <Link to="/privacy">Privacy Policy</Link>.
          </p>
        </section>

        <section className="ink-legal-section">
          <h2>10. Toepasselijk recht en bevoegde rechtbank</h2>
          <p>
            Op deze overeenkomst is uitsluitend het Belgisch recht van toepassing.
            Geschillen behoren tot de exclusieve bevoegdheid van de rechtbanken van
            het gerechtelijk arrondissement Oost-Vlaanderen, afdeling Dendermonde.
          </p>
        </section>

        <Link to="/" className="btn-gold ink-legal-back" data-testid="legal-back-btn">
          <span>← Terug naar home</span>
        </Link>
      </main>
    </div>
  );
}
